import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import { enrichPlayersWithAdditionalData, fetchFullPlayersData, getPlayersWithOptions } from './playerApis';
import type { PlayerItem, RelatedPlayersOptions } from './types';

export const useRelatedPlayersFetcher = (options: RelatedPlayersOptions) => {
  const fetchRelatedPlayers = useCallback(async () => {
    if (!options.fieldPosition) return [];

    let playerItems: PlayerItem[] = [];

    if (options.isClub || !options.competitionId) {
      playerItems = await getPlayersWithOptions(playerItems, options, 'club');
      playerItems = await getPlayersWithOptions(playerItems, options, 'team');
    } else {
      playerItems = await getPlayersWithOptions(playerItems, options, 'team');
      playerItems = await getPlayersWithOptions(playerItems, options, 'club');
    }

    const playerIds = playerItems.map((player) => player.id);
    if (!playerIds.length) return [];

    const fullPlayers = await fetchFullPlayersData(options, playerIds);
    return await enrichPlayersWithAdditionalData(fullPlayers, playerItems, options);
  }, [options]);

  const { data: players, isLoading } = useQuery({
    queryKey: ['related-players', options],
    queryFn: fetchRelatedPlayers,
    placeholderData: [],
  });

  return { players, isLoading };
};
